<template>
  <div class="settlement-page">
    <WithdrawCard></WithdrawCard>
    <!-- <IndexPageTable></IndexPageTable> -->
    <masking v-if="!isDeveloper" style="padding: 0 0 200px"></masking>
  </div>
</template>

<script>
import Masking from '@/components/Masking';
import WithdrawCard from './components/settlementCenter/withdrawCard';
// import IndexPageTable from './components/settlementCenter/indexPageTable';
import { mapState } from 'vuex';
export default {
  name: 'settlement',
  components: {
    WithdrawCard,
    // IndexPageTable,
    Masking,
  },
  mounted() {
    this.Report('view', 'PersonalSettlementPage');
  },
  computed: {
    ...mapState(['developerInfo']),
    isDeveloper() {
      return [1, 2].includes(this.developerInfo.state);
    },
  },
};
</script>

<style></style>
